import {microviewHostComponentFactory} from '@tableau/microview/lib/src/MicroviewHostComponentFactory';
import {MicroviewSuperHostService} from '@tableau/microview/lib/src/MicroviewHostService';
import {searchMetadata} from '@tableau/search-microview-communication-channels/lib/src/metadata/Metadata';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { LocalizationLoader } from '~src/commonInfra/services/LocalizationLoader';
import { MapDispatchToProps, MapStateToProps } from '~src/commonInfra/utils/ConnectUtils';
import { listenToCommonCommunicationChannels } from '~src/microview/CommonCommunicationChannelsListener';
import { getSessionManagementServiceInstance, SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import * as CollectionFavoriteStateListener from '../communicationChannelListeners/CollectionListener';
import * as DataConnectionListener from '../communicationChannelListeners/DataConnectionListener';
import * as FavoriteListener from '../communicationChannelListeners/FavoriteListener';
import * as HelpServiceListener from '../communicationChannelListeners/HelpServiceListener';
import * as MetricDataPointsListener from '../communicationChannelListeners/MetricDataPointListeners';
import * as SearchEPTListner from '../communicationChannelListeners/SearchEPTListner';


export type SearchMicroViewOwnProps = {};
export type SearchMicroViewStateProps = { locale: string }
export type SearchMicroViewHostProps = SearchMicroViewOwnProps & SearchMicroViewHostDispatchProps & SearchMicroViewStateProps;

const spaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'search',
    subspaceName: 'views'
};

function getLocale(): string {
    const sessionManagementService: SessionManagementService = getSessionManagementServiceInstance();
    const language = sessionManagementService.sessionLanguage() ?? ServerSettingsUnauthenticated.serverLanguage();
    const localeResult = LocalizationLoader.selectLocaleOrDefault(language);
    return localeResult;
}

// Listen for all Common Communication Channels, might be moved to a more top level file
if (FeatureFlags.genericMicroview){
    listenToCommonCommunicationChannels();
}

// Bootstrapping for search microview
if (FeatureFlags.genericMicroview){
    MicroviewSuperHostService.instance.bootstrapMicroview(searchMetadata, getLocale,listenToSpecificCommunicationChannels);
}

const enterSpaceForSearchMicroview = (props: SearchMicroViewHostProps) => {
    const { enterSpace } = props;
    enterSpace(spaceInfo);
};

export const SearchMicroViewHostWithGenericPackage = microviewHostComponentFactory<SearchMicroViewHostProps>(searchMetadata, enterSpaceForSearchMicroview);

function listenToSpecificCommunicationChannels() {
    DataConnectionListener.startListening();
    MetricDataPointsListener.startListening();
    HelpServiceListener.startListening();
    SearchEPTListner.startListening();
    CollectionFavoriteStateListener.startListening();
    FavoriteListener.startListening();
}

export interface SearchMicroViewHostDispatchProps {
    readonly enterSpace: (spaceInfo: SpaceInfo) => void;
}

const mapDispatchToProps: MapDispatchToProps<SearchMicroViewHostDispatchProps> = (dispatch) => bindActionCreators({
    enterSpace,
}, dispatch);

const mapStateToProps: MapStateToProps<SearchMicroViewStateProps> = () => ({
    locale: getLocale()
});

export const ConnectedSearchMicroViewHostWithGenericPackage: React.ComponentClass<SearchMicroViewOwnProps> = connect(mapStateToProps, mapDispatchToProps)(SearchMicroViewHostWithGenericPackage);
